import { LowerCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { PersonEntity } from '@nk/data-entities-lib';
import { HighlightTextPipe } from '@nk/ui-lib';
import * as dayjs from 'dayjs';
import { PersonBirthDateComponent } from '../person-birth-date/person-birth-date.component';

@Component({
  selector: 'nk-person-title',
  imports: [LowerCasePipe, PersonBirthDateComponent, HighlightTextPipe],
  templateUrl: './person-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PersonTitleComponent {
  public person = input<Partial<PersonEntity> | null>(null);
  public showFlag = input<boolean>(false);
  public showDate = input<boolean>(false);
  public flagRight = input<boolean>(false);
  public highlightText = input<string | undefined>(undefined);

  public birthDate = computed(() => {
    const person = this.person();
    if (!person) {
      return null;
    }
    if (person.birth_date) {
      const birthDate = dayjs(person.birth_date);
      if (birthDate.isValid()) {
        return birthDate.toDate();
      }
    }
    return null;
  });
}
